export default {
  admin: (state) => state.admin,
}
